<template>
  <div>
    <Scene1/>
    <Scene2/>
    <Scene3/>
    <Scene4/>
  </div>
</template>

<script>
import { Sprite, Container } from 'pixi.js'
import ChapterMixin from '@/mixins/Chapter'
import Scene1 from './scenes/Scene1'
import Scene2 from './scenes/Scene2'
import Scene3 from './scenes/Scene3'
import Scene4 from './scenes/Scene4'

export default {
  name: 'ConfederationHall',
  mixins: [ ChapterMixin ],
  components: { Scene1, Scene2, Scene3, Scene4 },
}
</script>
